<template>
  <div>
    <!-- Header -->
    <div class="header py-7 pt-lg-9">
      <b-container class="container">
        <div class="header-body text-center mb-7">
          <b-row class="justify-content-center">
            <b-col xl="5" lg="6" md="8" class="px-5">
              <h1 class="text-white" style="text-shadow: 1px 0px #000;">Sign up and get Clarity on your business NOW!</h1>
            </b-col>
          </b-row>
        </div>
      </b-container>
    </div>
    <!-- Page content -->
    <b-container class="mt--9 pb-5">
      <!-- Table -->
      <validation-observer v-slot="{handleSubmit}" ref="formValidator">
        <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
          <div v-if="step == 0">
            <div>
              <b-row class="justify-content-center plans">
                <b-col lg="6" md="12">
                  <b-card class="overflow-hidden">
                    <b-card-body>
                      <b-row>
                        <b-col class="text-center">
                          <h3 class="card-title mb-3">ClarityNOW Enterprise</h3>
                          <h3>Welcome to ClarityNOW Enterprise.</h3>
                          <p class="mb-1"><strong>How can your tech stack for your agents be improved?</strong></p>
                          <p><strong>Provide every agent in your office with a ClarityNOW Account.</strong></p>
                          <b-button block variant="danger" size="lg" @click="selectPlan">GET STARTED</b-button>
                        </b-col>
                      </b-row>
                    </b-card-body>
                  </b-card>
                </b-col>
              </b-row>
            </div>
          </div>
          <div v-if="step == 1">
            <b-row class="justify-content-center">
              <b-col lg="10" md="12">
                <b-card>
                  <b-card-body>
                    <b-row>
                      <b-col md="6" class="border-right pr-5">
                        <div class="text-center text-muted mb-4">
                          <h2>Registration</h2>
                          <small>Have an account? Then please <a href="/">Login Here</a></small>
                        </div>
                        <base-input alternative
                                    class="mb-3"
                                    prepend-icon="ni ni-hat-3"
                                    placeholder="Company Name"
                                    name="Company Name"
                                    :rules="{required: true}"
                                    v-model="model.enterprise_name">
                        </base-input>

                        <base-input alternative
                                    class="mb-3"
                                    prepend-icon="ni ni-hat-3"
                                    placeholder="Name"
                                    name="Name"
                                    :rules="{required: true}"
                                    v-model="model.name">
                        </base-input>

                        <base-input alternative
                                    class="mb-3"
                                    prepend-icon="ni ni-email-83"
                                    placeholder="Email"
                                    name="Email"
                                    :rules="{required: true, email: true}"
                                    v-model="model.email">
                        </base-input>

                        <base-input alternative
                                    class="mb-3"
                                    prepend-icon="ni ni-lock-circle-open"
                                    placeholder="Password"
                                    type="password"
                                    name="Password"
                                    :rules="{required: true, min: 6}"
                                    v-model="model.password"
                                    ref="password">
                        </base-input>
                        <base-input alternative
                                    class="mb-3"
                                    prepend-icon="ni ni-lock-circle-open"
                                    placeholder="Confirm Password"
                                    type="password"
                                    name="Confirm Password"
                                    :rules="{required: true, min: 6, is: model.password}"
                                    v-model="model.password_confirmation">
                        </base-input>
                        <div class="text-center">
                          <b-button block variant="danger" @click="step = 2">NEXT</b-button>
                        </div>
                      </b-col>
                      <b-col md="6" class="pl-5">
                        <h2 class="mb-0">Payment Summary</h2>
                        <div class="pb-3 border-bottom"></div>
                        <div class="pt-4">
                          <p class="text-muted mb-2">ClarityNOW Enterprise Monthly Plan</p>
                          <b-row class="mb-5">
                            <b-col>
                              <span class="bold">
                                Billing Cycle: 
                                <span>Monthly</span>
                              </span>
                              <span class="bold float-right">{{ plan.unit_amount / 100 | currency_2 }}</span>
                            </b-col>
                          </b-row>
                          <b-row class="mt-4 pt-4 border-top">
                            <b-col class="p-3 bg-light-blue">
                              <div class="d-flex justify-content-between align-items-center">
                                <span class="bold">Total due today</span>
                                <div>
                                  <span class="h2 mb-0">{{ plan.unit_amount / 100 | currency_2 }}</span>
                                </div>
                              </div>
                              <p class="small mt-2"><sup>**</sup>Minimum 6 month commitment. Recurring billing will be every {{ cycle }}.</p>
                            </b-col>
                          </b-row>
                        </div>
                      </b-col>
                    </b-row>
                  </b-card-body>
                </b-card>
              </b-col>
            </b-row>
          </div>

          <div v-if="step == 2">
            <b-row class="justify-content-center">
              <b-col lg="10" md="12">
                <b-card>
                  <b-card-body>
                    <b-row>
                      <b-col md="6" class="border-right pr-5">
                        <div v-if="!showLoginForm">
                          <div class="text-center text-muted mb-4">
                            <h2>Registration</h2>
                            <small>Have an account? Then please <a href="/">Login Here</a></small>
                          </div>

                          <base-input alternative
                                      class="mb-3"
                                      prepend-icon="ni ni-map-big"
                                      placeholder="City"
                                      name="City"
                                      :rules="{required: true}"
                                      v-model="model.city">
                          </base-input>

                          <base-input>
                            <state-select v-model="model.state" :required="true"></state-select>
                          </base-input>

                          <base-input alternative
                                      class="mb-3"
                                      prepend-icon="ni ni-mobile-button"
                                      placeholder="Phone"
                                      name="Phone"
                                      :rules="{required: true}"
                                      v-model="model.phone">
                          </base-input>

                          <base-input label-for="team_member" name="Realty Role">
                            <el-select v-model="model.realty_role" placeholder="Select Real Estate Role">
                              <el-option v-for="(role, index) in roles"
                                         :key="index"
                                         :label="role.text"
                                         :value="role.value">
                              </el-option>
                            </el-select>
                          </base-input>

                          <div v-if="errors">
                            <ul class="text-danger">
                              <li v-for="(error, index) in errors" :key="index" class="small">
                                {{ error.toString() }}
                              </li>
                            </ul>
                          </div>

                          <b-button block variant="outline-danger" @click="showLoginForm = true" v-if="errors">Login</b-button>
                          <div class="text-center mt-4 d-flex" v-else>
                            <b-button variant="outline-danger" @click="step = 1" class="flex-fill">BACK</b-button>
                            <b-button type="submit" variant="danger" :disabled="disabled" class="flex-fill"><span v-html="registerBtn"></span></b-button>
                          </div>
                        </div>
                        <div v-else>
                          <div class="text-center text-muted mb-4">
                            <h2>Login</h2>

                            <base-input alternative
                                        class="mb-3"
                                        name="Email"
                                        :rules="{required: true, email: true}"
                                        prepend-icon="ni ni-email-83"
                                        placeholder="Email"
                                        v-model="loginForm.email">
                            </base-input>

                            <base-input alternative
                                        class="mb-3"
                                        name="Password"
                                        :rules="{required: true, min: 6}"
                                        prepend-icon="ni ni-lock-circle-open"
                                        type="password"
                                        placeholder="Password"
                                        v-model="loginForm.password">
                            </base-input>

                            <b-button block variant="success" @click="login(loginForm.email, loginForm.password)">Login</b-button>
                          </div>
                        </div>
                      </b-col>
                      <b-col md="6" class="pl-5 mt-4">
                        <h2 class="mb-0">Payment Summary</h2>
                          <div class="pb-3 border-bottom"></div>
                          <div class="pt-4">
                            <p class="text-muted mb-2">ClarityNOW Enterprise Monthly Plan</p>
                            <b-row class="mb-5">
                              <b-col>
                                <span class="bold">
                                  Billing Cycle: 
                                  <span>Monthly</span>
                                </span>
                                <span class="bold float-right">{{ plan.unit_amount / 100 | currency_2 }}</span>
                              </b-col>
                            </b-row>
                            <b-row class="mt-4 pt-4 border-top">
                              <b-col class="p-3 bg-light-blue">
                                <div class="d-flex justify-content-between align-items-center">
                                  <span class="bold">Total due today</span>
                                  <div>
                                    <span class="h2 mb-0">{{ plan.unit_amount / 100 | currency_2 }}</span>
                                  </div>
                                </div>
                                <p class="small mt-2"><sup>**</sup>Minimum 6 month commitment. Recurring billing will be every {{ cycle }}.</p>
                              </b-col>
                            </b-row>
                          </div>
                      </b-col>
                    </b-row>
                  </b-card-body>
                </b-card>
              </b-col>
            </b-row>
          </div>
        </b-form>
      </validation-observer>

      <div v-if="step == 3">
        <b-row class="justify-content-center">
          <b-col lg="10" md="12">
            <b-card>
              <b-card-body>
                <b-row>
                  <b-col md="6" class="border-right pr-5">
                    <div class="text-center text-muted mb-4">
                      <h2>Registration</h2>
                      <small>Have an account? Then please <a href="/">Login Here</a></small>
                    </div>
                    <validation-observer v-slot="{handleSubmit}" ref="formValidator">
                      <b-form role="form">
                        <b-row>
                          <b-col>
                            <label for="card-holder-name" class="sr-only sr-only-focusable">Name on Card</label>
                            <base-input name="Name on Card"
                                        placeholder="Card Holder Name"
                                        rules="required"
                                        v-model="name">
                            </base-input>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col>
                            <div id="card-element" class="form-control"></div>
                          </b-col>
                        </b-row>
                        <b-row class="mt-3">
                          <b-col cols="12">
                            <base-input :rules="{ required: { allowFalse: false } }" name="Privacy Policy">
                              <b-form-checkbox v-model="auto_renewal">
                                <span class="text-muted">I agree with the <a href="https://www.claritynowre.com/privacy-policy" target="_blank">Privacy Policy</a></span>
                              </b-form-checkbox>
                            </base-input>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col>
                            <small class="text-danger">
                              Automatic Renewal Notice: Your ClarityNOW membership will automatically renew every month and your membership will continue until you cancel. No minimum purchase required. Your credit card or selected payment method will be used for your membership, and will continue to be used monthly. You can cancel your membership or change your selected payment method at any time.
                            </small>
                          </b-col>
                        </b-row>
                        <div class="text-center mt-4 d-flex">
                          <b-button variant="outline-danger" @click="step = 2" class="flex-fill">BACK</b-button>
                          <b-button type="submit" variant="danger" :disabled="paymentDisabled" class="flex-fill" @click="submitPaymentMethod">SUBSCRIBE</b-button>
                        </div>
                      </b-form>
                    </validation-observer>
                  </b-col>
                  <b-col md="6" class="pl-5 mt-4">
                    <h2 class="mb-0">Payment Summary</h2>
                    <div class="pb-3 border-bottom"></div>
                    <div class="pt-4">
                      <p class="text-muted mb-2">ClarityNOW Enterprise Monthly Plan</p>
                      <b-row class="mb-5">
                        <b-col>
                          <span class="bold">
                            Billing Cycle: 
                            <span>Monthly</span>
                          </span>
                          <span class="bold float-right">{{ plan.unit_amount / 100 | currency_2 }}</span>
                        </b-col>
                      </b-row>
                      <b-row class="mt-4 pt-4 border-top">
                        <b-col class="p-3 bg-light-blue">
                          <div class="d-flex justify-content-between align-items-center">
                            <span class="bold">Total due today</span>
                            <div>
                              <span class="h2 mb-0">{{ plan.unit_amount / 100 | currency_2 }}</span>
                            </div>
                          </div>
                          <p class="small mt-2"><sup>**</sup>Minimum 6 month commitment. Recurring billing will be every {{ cycle }}.</p>
                        </b-col>
                      </b-row>
                    </div>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
</template>

<script>
import axios from 'axios';
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';
import StateSelect from "@/views/Components/Forms/StateSelect";
import {Select, Option} from 'element-ui';
import errorsMixin from "@/mixins/errors-mixin";

export default {
  name: 'register',
  mixins: [errorsMixin],
  components: {
    StateSelect,
    [Select.name]: Select,
    [Option.name]: Option
  },
  data() {
    return {
      model: {
        enterprise_name: '',
        name: '',
        email: '',
        city: '',
        state: '',
        phone: '',
        password: '',
        password_confirmation: '',
        team: '',
        realty_role: null,
        affiliate: '',
        pulse: false,
        kwyp: false,
      },
      roles: [
        {
          value: 'Office/Broker',
          text: 'Office/Broker'
        },
        {
          value: 'Rainmaker',
          text: 'Rainmaker'
        },
        {
          value: 'Solo Agent',
          text: 'Solo Agent'
        },
        {
          value: 'Listing Agent',
          text: 'Listing Agent'
        },
        {
          value: 'Buyers Agent',
          text: 'Buyers Agent'
        },
        {
          value: 'Admin',
          text: 'Admin'
        },
        {
          value: 'ISA',
          text: 'ISA'
        },
        {
          value: 'Real Estate Coach',
          text: 'Real Estate Coach'
        },
        {
          value: 'Other',
          text: 'Other'
        },
      ],
      errors: null,
      registerBtn: 'REGISTER',
      disabled: false,
      paymentDisabled: false,
      step: 0,
      stripeAPIToken: '',
      intentToken: '',
      stripe: '',
      elements: '',
      card: '',
      name: null,
      payment_method: null,
      auto_renewal: false,
      plan: null,
      products: [],
      showLoginForm: false,
      loginForm: {
        email: '',
        password: ''
      },
      term: false,
    }
  },
  computed: {
    passwordConfirmed() {
      return this.model.password == this.model.confirm_password;
    },
    user() {
      return this.$store.getters['profile/user'];
    },
    userRoute() {
      return this.$store.getters['profile/userRoute'];
    },
    authenticated() {
      return this.$store.getters['isAuthenticated'];
    },
    cycle() {
      if (this.plan.id == this.products[0].id) {
        return "month";
      } else if (this.plan.id == this.products[1].id) {
        return "6 months";
      } else {
        return "year";
      }
    }
  },
  methods: {
    async onSubmit() {
      this.disabled = true;
      this.registerBtn = '<i class="fas fa-spinner fa-pulse"></i> PROCESSING...';

      axios.post(process.env.VUE_APP_API_BASE_URL + "/register", this.model)
      .then(response => {
        this.login(this.model.email, this.model.password);
        this.partnerStackSignup();
      })
      .catch(error => {
        this.registerBtn = 'REGISTER';
        this.errors = error.response.data.errors;
        this.error(error);
      });
    },
    async login(email, password) {
      const user = {
        email: email,
        password: password
      }

      const requestOptions = {
        headers: {
          Accept: "application/vnd.api+json",
          "Content-Type": "application/vnd.api+json",
        },
      };

      try {
        await this.$store.dispatch("login", { user, requestOptions });        
        swal.fire({
          title: `Success`,
          text: 'Welcome to ClarityNOW!',
          showConfirmButton: false,
          timer: 1750,
          icon: 'success'
        }).then(result => {
          this.setupStore();

          if (this.plan) {
            this.step = 3;

          } else {
            this.$router.push({
              path: '/home'
            });
          }
        });
      } catch(error) {
        this.error(error);
        this.setApiValidation(error.response.data.errors);
      }
    },
    partnerStackSignup() {
      growsumo.data.name = this.model.name;
      growsumo.data.email = this.model.email;
      growsumo.data.customer_key = this.model.email;
      growsumo.createSignup();
    },
    async getPlans() {
      axios.get(process.env.VUE_APP_API_BASE_URL + "/active-plans/enterprise")
      .then(response => {
        this.products = response.data.data;
      })
      .catch(error => {
        this.error(error);
      });
    },
    async getStripeKey() {
      axios.get(process.env.VUE_APP_API_BASE_URL + '/stripe-key')
      .then(response => {
        this.stripeAPIToken = response.data;
      })
      .catch(error => {
        this.error(error);
      });
    },
    includeStripe(URL, callback){
      let documentTag = document, tag = 'script',
          object = documentTag.createElement(tag),
          scriptTag = documentTag.getElementsByTagName(tag)[0];
      object.src = '//' + URL;
      if (callback) { object.addEventListener('load', function (e) { callback(null, e); }, false); }
      scriptTag.parentNode.insertBefore(object, scriptTag);
    },
    configureStripe(){
      this.stripe = Stripe(this.stripeAPIToken);

      this.elements = this.stripe.elements();
      this.card = this.elements.create('card');

      this.card.mount('#card-element');
    },
    async submitPaymentMethod() {
      this.paymentDisabled = true;
      this.addPaymentStatus = 1;

      this.stripe.confirmCardSetup(
        this.intentToken.client_secret, {
          payment_method: {
            card: this.card,
            billing_details: {
                name: this.name
            }
          }
        }
      ).then(result => {
        if (result.error) {
          this.addPaymentStatus = 3;
          this.addPaymentStatusError = result.error.message;
          this.disabled = false;
        } else {
          this.payment_method = result.setupIntent.payment_method;
          this.subscribe();
        }
      });
    },
    async subscribe() {
      axios.post(this.userRoute + "/subscribe", {
        payment_method: this.payment_method,
        plan: this.plan.id
      })
      .then(response => {
        swal.fire({
          title: `Success`,
          text: 'Subscription Created Successfully',
          showConfirmButton: false,
          timer: 1750,
          icon: 'success'
        }).then(result => {
          this.$router.push({
            path: '/home'
          });
        });
      })
      .catch(error => {
        this.error(error);
      });
    },
    setupStore() {
      this.$store.dispatch("roles/get");
      this.$store.dispatch("teams/get", {user: this.user.slug});
      this.$store.dispatch("teams/member", {user: this.user.slug});
      this.getIntent();
    },
    async getIntent() {
      axios.get(this.userRoute + "/payment-setup")
      .then(response => {
        this.intentToken = response.data.intent;
      })
      .catch(error => {
        this.error(error);
      });
    },
    selectPlan() {
      this.plan = this.products[0];
      
      if (this.authenticated) {
        this.getIntent();
        this.step = 3;
      } else {
        this.step = 1;
      }
    },
    getCoupon() {
      axios.post(process.env.VUE_APP_API_BASE_URL + "/stripe/coupon", {
        coupon: this.$route.query.coupon
      })
      .then(response => {
        if (response.data.id) {
          this.coupon = response.data.id;
          this.couponInfo = response.data;
        }
      })
      .catch(error => {
        // 
      });
    }
  },
  created() {
    this.getPlans();
    this.getStripeKey();

    if (this.$route.query.affiliate) {
      this.model.affiliate = this.$route.query.affiliate;
    }

    if (this.$route.query.coupon) {
      this.getCoupon();
    }

    if (this.$route.query.pulse) {
      this.model.pulse = true;
    }

    if (this.$route.query.kwyp) {
      this.model.kwyp = true;
    }
  },
  watch: {
    step(to, from) {
      if (to == 3) {
        this.includeStripe('js.stripe.com/v3/', function(){
          this.configureStripe();
        }.bind(this));
      }
    }
  }
};
</script>
<style lang="scss">
.plans {
  .card-body {
    padding-top: 10px;
    background-image: url('/img/plans-background.png');
    background-size: 100% auto;
  }
  .card-title {
    margin-bottom: 0;
    font-size: 28px;
    font-weight: bold;
    text-shadow: 0px 0px 1px #222222;
    color: #CE5E5E;
  }
  h1 {
    text-transform: uppercase;
    font-weight: bold;
  }
  h5 {
    font-weight: bold;
    padding-top: 2px;
    padding-bottom: 2px;
    text-align: center;
    text-transform: uppercase;
  }

  ul {
    font-size: 13px;
    margin-bottom: 0.5rem;
    font-weight: normal;

    li {
      line-height: 19px;
    }
  }
}

.bg-light-blue {
  background-color: rgba(173, 216, 230, 0.3);

}
</style>
